import React from 'react';
import { Button, Typography, Divider, Box } from '@common-ui/ui';
import { ModeEdit, Delete } from '@mui/icons-material';
import tiComponentEnum from '../../enums/tiComponentEnum';
import { getDateWithTimeZone } from '../../utils/dateFormatter';
import routerPathEnum from '../../enums/routerPathEnum';
import { useAppDispatch } from '../../store/configureStore';
import { useHistory } from 'react-router';
import { remove_image_from_columbia } from '../../store/services/work-item/handle-columbia';

const WorkItemImageHeader = ({ image }) => {
  const {
    imageJSON: {
      main: { origin_path, date_taken, date_taken_milliseconds, user_timezone, image_id },
    },
  } = image;
  const history = useHistory();
  const dispatch = useAppDispatch();

  const getDateFormat = () => {
    return getDateWithTimeZone(date_taken_milliseconds ?? date_taken, user_timezone ?? 'UTC');
  };

  return (
    <Box className="workItem__imageHeader">
      <Box>
        <Typography variant="h5" mb={1}>
          {tiComponentEnum.IMAGE_NAME} {origin_path}
        </Typography>
        <Typography>
          {tiComponentEnum.IMAGE_DATE} {getDateFormat()}
        </Typography>
      </Box>
      <Box className="workItem__buttonContainer" sx={buttonContainer}>
        <Button
          startIcon={<ModeEdit />}
          className="workItem__button"
          onClick={() =>
            history.push({
              pathname: `${routerPathEnum.IMAGE_EDITOR}/${image_id}`,
            })
          }
        >
          {tiComponentEnum.ANALYZE}
        </Button>
        <Divider orientation="vertical" variant="middle" />
        <Button
          className="workItem__button"
          startIcon={<Delete />}
          onClick={() => dispatch(remove_image_from_columbia(image_id))}
        >
          {tiComponentEnum.REMOVE}
        </Button>
      </Box>
    </Box>
  );
};

export default WorkItemImageHeader;

const buttonContainer = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};
